import { render, staticRenderFns } from "./ModeOfPayment.vue?vue&type=template&id=5c034e81"
import script from "./ModeOfPayment.vue?vue&type=script&lang=js"
export * from "./ModeOfPayment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports